export default "__VITE_ASSET__CkW4pqtl__"